export const iconFontAwesomePhotosImagesMinimize = (
	<i className="fa-solid fa-minimize"></i>
);
